import { createEntity } from "shadow-client";
import { product } from "shadow-client/endpoints/productApi/schemas";

export const sale = createEntity("sales", {});
export const article = createEntity("articles", {});
export const articleBehaviors = createEntity("articleBehaviors", {});

export const cartArticle = createEntity("articles", {
  productId: product
});



// WEBPACK FOOTER //
// ./src/shadow-client/endpoints/saleApi/schemas.js